import { injectable } from 'inversify';

import { HttpService } from '../http';
import { FileType } from '../file-type';

@injectable()
export class ImageConverter {
  constructor(
    private http: HttpService,
    private fileType: FileType,
  ) {}

  private static SUPPORTED_TYPES = [
    'image/heic',
    'image/heif',
    'image/tiff',
    'image/dng',
    'image/x-adobe-dng',
  ];

  async convert(image: Blob) {
    const detectedType = await this.fileType.fileTypeFromBlob(image);
    const imageType = detectedType ?? image.type;

    if (imageType === 'image/jpeg') {
      return image;
    }

    if (!ImageConverter.SUPPORTED_TYPES.includes(imageType)) {
      throw new Error('Неподдерживаемый тип изображения');
    }

    const result = await this.http.generateFile('/tools/image/convert', {
      image,
    });

    return result;
  }
}
